<template>
  <v-container class="layout-container">
    <HelpCenter :company="company" />
  </v-container>
</template>

<script>
import { defineAsyncComponent } from 'vue'

import COMPANY_BASE from '../queries/CompanyBase.gql'

export default {
  components: {
    HelpCenter: defineAsyncComponent(() => import('@/modules/helpCenter')),
  },
  apollo: {
    company: {
      query: COMPANY_BASE,
      variables() {
        return {
          id: this.$auth.user.companyId,
        }
      },
    },
  },
}
</script>
